import { Theme } from '@mui/material/styles';
import { PaletteColor } from '@mui/material';

export function getColorByName(name: string) {
  const character = (name: string) => name && name.charAt(0).toUpperCase();

  const colorByName = (name: string) => {
    if (['A', 'N', 'H', 'L', 'Q'].includes(character(name))) return 'primary';
    if (['F', 'G', 'T', 'I', 'J'].includes(character(name))) return 'info';
    if (['K', 'D', 'Y', 'B', 'O'].includes(character(name))) return 'success';
    if (['P', 'E', 'R', 'S', 'U'].includes(character(name))) return 'warning';
    if (['V', 'W', 'X', 'M', 'Z'].includes(character(name))) return 'error';
    return 'default';
  };

  return {
    name: character(name),
    color: colorByName(name),
  } as const;
}

export function getPaletteColorByName(name: string, theme: Theme): PaletteColor {
  const { color } = getColorByName(name);

  if (color === 'default') {
    return theme.palette.primary;
  }

  return theme.palette[color];
}
